import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { useTranslate } from '../common/language';
import { Link } from 'react-router-dom';
import { dateAndTimeToCatalan, headersAPIObjectAuth } from '../common/utils';
import { apiUrl } from '../common/constants';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const TicketsMapAssignments = ({ record }) => {
  const translate = useTranslate();
  const [open, setOpen] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const mapId = record && record.id;

  useEffect(() => {
    if (!open || !mapId) return undefined;
    let active = true;
    setLoading(true);
    setError('');
    setAssignments([]);
    fetch(apiUrl + '/tickets_maps/' + mapId + '/assignments', { headers: headersAPIObjectAuth() })
      .then(async response => {
        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          throw new Error(body.message || translate('tickets_maps.assignments_error'));
        }
        return response.json();
      })
      .then(data => { if (active) setAssignments(data.assignments || []); })
      .catch(err => { if (active) setError(err.message || translate('tickets_maps.assignments_error')); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open, mapId, translate]);

  if (!record) return null;
  return (
    <Box onClick={event => event.stopPropagation()}>
      <Box display="flex" alignItems="center" gap={1}>
        <span>{record.sessions_count || 0}</span>
        <Tooltip title={translate('tickets_maps.assignments_info')}>
          <IconButton size="small" aria-label={translate('tickets_maps.assignments_info') + ': ' + record.name} onClick={() => setOpen(true)}>
            <InfoOutlinedIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md" aria-labelledby={'map-assignments-title-' + mapId}>
        <DialogTitle id={'map-assignments-title-' + mapId}>{translate('tickets_maps.sessions_assigned_to_map')}</DialogTitle>
        <DialogContent dividers>
          {loading ? <Box role="status" display="flex" alignItems="center" gap={2}><CircularProgress size={24} /><span>{translate('ra.message.loading')}</span></Box> : error ? (
            <Typography color="error" role="alert">{error}</Typography>
          ) : assignments.length === 0 ? (
            <Typography>{translate('tickets_maps.assignments_empty')}</Typography>
          ) : (
            <Box sx={{ overflowX: 'auto' }}>
              <Table>
                <TableHead><TableRow>
                  <TableCell>{translate('tickets_maps.assignment_event')}</TableCell>
                  <TableCell>{translate('tickets_maps.assignment_session')}</TableCell>
                  <TableCell>{translate('tickets_maps.assignment_date')}</TableCell>
                </TableRow></TableHead>
                <TableBody>{assignments.map(item => (
                  <TableRow key={item.id}>
                    <TableCell component={Link} to={`/events/${item.events_id}/sessions`} style={{ color: 'inherit', textDecoration: 'underline' }}>{item.event_name}</TableCell>
                    <TableCell>{item.session_name || '—'}</TableCell>
                    <TableCell>{item.date_start ? <Link to={`/events_sessions/${item.id}`}>{dateAndTimeToCatalan(item.date_start)}</Link> : '—'}</TableCell>
                  </TableRow>
                ))}</TableBody>
              </Table>
            </Box>
          )}
        </DialogContent>
        <DialogActions><Button onClick={() => setOpen(false)}>{translate('ra.action.close')}</Button></DialogActions>
      </Dialog>
    </Box>
  );
};
